import { useInstrument } from "./useInstruments";
import { formatDateApi } from "../utils";
import { useDispatch } from "react-redux";
import { saveLinkDownload as saveLinkDownloadRedux } from "../store/slice/trade";

const appSettings = window.appSettings;


const useSaveLinkDownload = () => {
  const [{ selectedInstrument }] = useInstrument();
  const dispatch = useDispatch();
  
/**
 *
 * @param { string} currency
 * @param { {from: string, to: string}} rangePicker
 */
  const saveLinkDownLoad = (rangePicker, currency) => {
    let shares = "";
    let index = 0;
    for (let x in selectedInstrument) {
      const item = selectedInstrument[x] || {};
      if (index !== 0) shares += ",";
      shares += `${item.instrumentId};${item.iSIN};${item.marketID};${item.currencyCode}`;
    }
    const dataQuery = {
      currency,
      fromDate: rangePicker?.from ? formatDateApi(rangePicker.from) : null,
      toDate: rangePicker?.to ? formatDateApi(rangePicker.to) : null,
      shares,
    };
    const linkDownload = `download/excel/?lang=${appSettings.language || "en-gb"}&companyCode=${appSettings.companyCode}&v=${appSettings.companyCodeVersion ?? ''}&fromDate=${dataQuery.fromDate}&toDate=${dataQuery.toDate}&currency=${dataQuery.currency || ''}&shares=${dataQuery.shares}`;
    dispatch(saveLinkDownloadRedux(linkDownload));
  };
  return { saveLinkDownLoad };
};

export default useSaveLinkDownload;
